import { cn } from "@/lib/utils";

export const PERIODS = [
  { days: 7, label: "7 days" },
  { days: 30, label: "30 days" },
  { days: 90, label: "90 days" },
] as const;

/** The segmented 7 / 30 / 90 day control that sits in a card's title row. */
export function PeriodToggle({
  value,
  onChange,
  disabled = false,
}: {
  value: number;
  onChange: (days: number) => void;
  disabled?: boolean;
}) {
  return (
    <div
      role="group"
      aria-label="Period"
      className="inline-flex items-center rounded-md bg-muted p-0.5"
    >
      {PERIODS.map((period) => {
        const active = value === period.days;
        return (
          <button
            key={period.days}
            type="button"
            aria-pressed={active}
            disabled={disabled}
            onClick={() => onChange(period.days)}
            className={cn(
              "rounded-[5px] px-2.5 py-1 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              active ? "bg-card text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"
            )}
          >
            {period.label}
          </button>
        );
      })}
    </div>
  );
}
